var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

$(document).ready(function(){
  $(function() {
    $('.icon-column-section .card-box__content').matchHeight();
  	$('.product-card-wrapper .product-card__information .product-card__information__wrapper').matchHeight();  
    $('.collection-grid-section .grid__item.data-pagination__item .product-card__information__wrapper .product-card__information__wrapper-inner').matchHeight();  
    
  });
  
   $(document).on('change','.prescription',function(){
     if($('.prescription').is(':checked')){ 
       $(".product-form__buy-buttons").show();  
     }else{
       $(".product-form__buy-buttons").hide(); 
     }
    }); 
  
 });
 